
import ReasonCodeComponent from   "~/components/pages/supervisor/reasoncode";
export default function ReasonCodePage() {

 
  return (
<div >
<ReasonCodeComponent/>
</div>
  );
}